import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { DeviceQueries } from 'Common/src/components/styled';

export const BasePageContent = ({ $showFooter, $wide, $full, children }: PropsWithChildren<{
  $showFooter: boolean,
  $wide?: boolean,
  $full?: boolean
}>) => {

  return <BasePageContentOuter>
    <BasePageContentInner $showFooter={$showFooter} $wide={$wide} $full={$full}>
      {children}
    </BasePageContentInner>
  </BasePageContentOuter>;
}

const BasePageContentOuter = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Poppins, sans-serif;

  @media not (${DeviceQueries.smallMobile}) {
    overflow-x: auto;
  }
`;

const BasePageContentInner = styled.div<{ $showFooter: boolean, $wide?: boolean, $full?: boolean }>`
  position: relative;
  padding: 0 25px 25px 25px;
  flex-grow: 1;

  @media not (${DeviceQueries.smallMobile}) {
    ${({ $wide = false }) => $wide ? '' : 'width: 400px;'}
    ${({ $full = false }) => $full ? 'width: calc(100% - 50px);' : ''}
  }

  @media (${DeviceQueries.smallMobile}) {
    width: calc(100% - 50px);
    max-width: calc(100vw - 40px);
    height: 100vh
  }
`;

export const TwoColumnLayout = styled.div<{ $gap?: number }>`
  display: flex;
  gap: ${({ $gap = 0 }) => $gap}px;
  justify-content: space-between;

  @media (${DeviceQueries.mobile}) {
    display: contents;
  }
`;

export const ShadedBox = styled.div`
  color: var(--shine-text-color);
  margin-bottom: 25px;
  padding: 5px 15px;
  border-radius: 8px;
  border: solid 1px rgba(255, 255, 255, 0.23);
  background-color: var(--shine-system-background-color);
`;

export const ShadedBoxTitle = styled.div`
  display: flex;
  padding: 10px 0;
  font-size: 24px;
`;
